import { Box, Text } from '@chakra-ui/react';
import * as React from 'react';
import { updateUser } from 'utils/sessionHelper';
import { SmallTweetPreview } from './smallTweetPreview';

export interface ISmallTweetGridProps {
  aiCustomPosts: any[];
  colorMode: string;
  session: any;
  setAiCustomPost: (aiCustomPosts: any[]) => void;
}

export function SmallTweetGrid({ aiCustomPosts, colorMode, session, setAiCustomPost }: ISmallTweetGridProps) {
  const deleteCustomPost = async (tweet) => {
    const newCustomPosts = aiCustomPosts.filter(x => x.id !== tweet.id);
    await updateUser(session, { aiCustomPosts: newCustomPosts.length ? newCustomPosts : [] }, true, true);
    setAiCustomPost(newCustomPosts.length ? newCustomPosts : []);
  }
  return (
    <Box as="section"
      id="loadedTweets"
      display="flex"
      {
      ...aiCustomPosts.length && {
        gridTemplateColumns: {
          base: "repeat(1, minmax(0, 1fr))",
          md: "repeat(3, minmax(0, 1fr))",
        },
        gridGap: 4,
        display: "grid",
      }}
      py={6}>
      {aiCustomPosts.length ? aiCustomPosts.map((tweet) => {
        return (
          <SmallTweetPreview
            handleDeletePost={deleteCustomPost}
            tweet={tweet} colorMode={colorMode}
            twUserName={tweet.twUserName}
            userImage={tweet.profile_image_url}
          />
        )
      }) : <Text w={"100%"}>No custom posts yet, add some above or disable custom posts usage</Text>}
    </Box>
  );
}
